var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"redirect-if-no-permission",rawName:"v-redirect-if-no-permission:LOCATIONS",arg:"LOCATIONS"}]},[_c('DataTable',{attrs:{"url":_vm.baseUri,"fieldsHiddenMain":[
    'deleted_at',
    'type',
    'landmark_type',
    'street_name',
    'place_id',
    'street_number',
  ],"perPage":"100","titles":_vm.titles,"actionsExtraMain":_vm.actionsExtraMain,"formatter":_vm.formatter,"title":_vm.blacklist ? _vm.$t('locationsPage.blacklistedSectorsTitle') : _vm.$t('locationsPage.sectorsTitle')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }